import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, Modal, FormHelperText
} from "@mui/material";
import { styled } from "@mui/system";
import { Add, Close } from "@mui/icons-material";
import Swal from "sweetalert2";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { hosturl } from "../libs/Constants";
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import QueueIcon from '@mui/icons-material/Queue';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import CircleIcon from '@mui/icons-material/FiberManualRecord';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
const HoroscopeForm = () => {
  const [gender, setGender] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [zodiac, setZodiac] = useState("");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [place, setPlace] = useState("");
  const [runningToken, setRunningToken] = useState(null);
  const [tokenToken, setTokenToken] = useState(null);
  const [user, setUser] = useState({});
  const [userId, setUserId] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [waitingTokens, setWaitingTokens] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [currentMember, setCurrentMember] = useState({
    name: "",
    gender: "",
    zodiac: "",
    date: null,
    time: null,
  });
  const [errorMessages, setErrorMessages] = useState({
    name: '',
    gender: '',
    zodiac: '',
    date: '',
  });

  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchUserDetails();

    const intervalId = setInterval(() => {
      if (userId) {
        fetchTokenStatus(userId);
      }
    }, 2000);

    return () => clearInterval(intervalId);
  }, [token, userId]);

  const fetchUserDetails = async () => {
    if (!token) {
      setError((prevError) => ({ ...prevError, token: 'Please log in to view your profile.' }));
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${hosturl}/user-details`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include',
      });

      const horoscope = response.data.user.horoscopeData;
      setName(horoscope.name);
      setPhoneNumber(horoscope.phoneNumber);
      setZodiac(horoscope.zodiac);
      setPlace(horoscope.place);
      setUserId(response.data.user._id);
      setDate(dayjs(horoscope.dob));

      if (horoscope.time) {
        const updatedTime = dayjs(horoscope.time);
        setTime(updatedTime);
      }

      setUser(response.data || {});
    } catch (err) {
      setError((prevError) => ({ ...prevError, fetchUser: 'An unexpected error occurred. Please login.' }));
    } finally {
      setLoading(false);
    }
  };

  const fetchTokenStatus = async (userId) => {
    if (!token || !userId) {
      console.error("Token or User ID is missing.");
      return;
    }

    try {
      const response = await axios.get(`${hosturl}/tokens/status/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data?.data) {
        const { lastCompletedToken, waitingTokens } = response.data.data;
        setRunningToken(lastCompletedToken);

        // Set user token (first in waiting list)
        const userToken = waitingTokens.length > 0 ? waitingTokens[0].queueNo : null;
        setTokenToken(userToken);

        // Store all waiting tokens
        setWaitingTokens(waitingTokens);
      }
    } catch (err) {
      console.error("Error fetching token status:", err);
      setError({
        ...error,
        tokenStatus: 'Failed to fetch token status.',
      });
    }
  };

  useEffect(() => {
    fetchTokenStatus(userId);

    // Refresh every 30 seconds
    const interval = setInterval(() => fetchTokenStatus(userId), 30000);
    return () => clearInterval(interval);
  }, [userId]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentMember({
      name: "",
      gender: "",
      zodiac: "",
      date: null,
      time: null,
    });
  };

  const handleMemberChange = (field, value) => {
    setCurrentMember(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addFamilyMember = () => {
    let errors = {
      name: '',
      gender: '',
      zodiac: '',
      date: '',
    };

    // Check for mandatory fields (name, gender, zodiac, and date)
    if (!currentMember.name) {
      errors.name = 'Name is required';
    }

    if (!currentMember.gender) {
      errors.gender = 'Gender is required';
    }

    if (!currentMember.zodiac) {
      errors.zodiac = 'Zodiac sign is required';
    }

    if (!currentMember.date) {
      errors.date = 'Date of Birth is required';
    }
    if (errors.name || errors.gender || errors.zodiac || errors.date) {
      setErrorMessages(errors);
      return;
    }
    const updatedMember = {
      ...currentMember,
      date: currentMember.date ? currentMember.date.toISOString() : null, // Convert date to ISO string
      time: currentMember.time ? currentMember.time.toISOString() : null, // Convert time to ISO string (optional)
    };

    setFamilyMembers([...familyMembers, updatedMember]);
    handleCloseDialog();
  };



  const removeFamilyMember = (index) => {
    const updatedMembers = [...familyMembers];
    updatedMembers.splice(index, 1);
    setFamilyMembers(updatedMembers);
  };

  const handleSubmit = () => {
    let formErrors = {};
    if (!name) formErrors.name = "Name is required.";
    if (!phoneNumber || phoneNumber.length !== 10) formErrors.phoneNumber = "Phone number is required.";
    if (!zodiac) formErrors.zodiac = "Zodiac sign is required.";
    if (!date) formErrors.date = "Date of birth is required.";
    if (!time) formErrors.time = "Time of birth is required.";
    if (!place) formErrors.place = "Place is required.";
    if (!gender) formErrors.gender = "Gender is required.";

    setError(formErrors);

    if (Object.keys(formErrors).length === 0) {
      // Ensure all family member dates and times are in ISO format
      const formattedFamilyMembers = familyMembers.map(member => ({
        ...member,
        date: member.date ? dayjs(member.date).toISOString() : null, // Ensure the family member's date is ISO formatted
        time: member.time ? dayjs(member.time).toISOString() : null, // Ensure the family member's time is ISO formatted
      }));

      const formData = {
        userId,
        name,
        gender,
        phoneNumber,
        zodiac,
        date,
        time,
        place,
        runningToken,
        tokenToken,
        familyMembers: formattedFamilyMembers,
      };
      navigate("/paymentgateway", { state: formData });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Background>
        {/* Token Section */}
        <TokenContainer>
          <TokenBox>
            <Typography fontSize="18px" fontWeight="bold">Running Appointment</Typography>
            <Typography fontSize="24px" fontWeight="bold">
              {runningToken && runningToken.tokenNo ? runningToken.tokenNo : "0"}
            </Typography>
          </TokenBox>

          <TokenBox>
            <Typography fontSize="18px" fontWeight="bold">Your Appointment</Typography>
            <Typography fontSize="24px" fontWeight="bold">
              {tokenToken ? tokenToken : "0"}
            </Typography>
          </TokenBox>

          {waitingTokens.length > 2 && (
            <WaitingTokenBox onClick={handleOpenModal}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                height="100%"
                position="relative"
              >
                <MoreTokensIndicator>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 12L12 8M16 12L12 16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#000"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <Typography
                    variant="caption"
                    fontSize="10px"
                    position="absolute"
                    bottom="0"
                    right="0"
                    bgcolor="#fff"
                    borderRadius="50%"
                    width="16px"
                    height="16px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="0 1px 3px rgba(0,0,0,0.2)"
                    sx={{
                      border: '1px solid #F1C451',
                      transform: 'translate(25%, 25%)'
                    }}
                  >
                    {waitingTokens.length - 2}
                  </Typography>
                </MoreTokensIndicator>
              </Box>
            </WaitingTokenBox>
          )}
        </TokenContainer>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="waiting-tokens-modal"
        >
          <ModalContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Typography variant="h5" fontWeight="bold" color="primary">
                <QueueIcon fontSize="large" sx={{ verticalAlign: 'middle', mr: 1 }} />
                Waiting Appointments
              </Typography>
              <IconButton
                onClick={handleCloseModal}
                sx={{
                  backgroundColor: 'rgba(241, 196, 81, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(241, 196, 81, 0.3)'
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
              {waitingTokens.map((token, index) => (
                <WaitingTokenItem key={index}>
                  <Box display="flex" alignItems="center" width="100%">
                    <Box sx={{
                      backgroundColor: token.status === 'waiting' ? '#e3f2fd' : '#ffebee',
                      borderRadius: '50%',
                      width: 40,
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2
                    }}>
                      {token.status === 'waiting' ? (
                        <AccessTimeIcon color="primary" />
                      ) : (
                        <WarningIcon color="error" />
                      )}
                    </Box>
                    <Box flexGrow={1}>
                      <Typography fontWeight="bold" fontSize="16px">
                        Token {token.queueNo}
                      </Typography>
                      <Typography
                        variant="caption"
                        color={token.status === 'waiting' ? 'textSecondary' : 'error'}
                        display="flex"
                        alignItems="center"
                      >
                        {token.status === 'waiting' ? (
                          <>
                            <CircleIcon sx={{ fontSize: 8, mr: 1 }} /> Waiting in queue
                          </>
                        ) : (
                          <>
                            <ErrorOutlineIcon sx={{ fontSize: 12, mr: 0.5 }} /> Status: {token.status}
                          </>
                        )}
                      </Typography>
                    </Box>
                    <Typography
                      variant="subtitle2"
                      color="textSecondary"
                    >
                      #{index + 1}
                    </Typography>
                  </Box>
                </WaitingTokenItem>
              ))}
            </Box>

            <Box mt={3} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                onClick={handleCloseModal}
                sx={{
                  backgroundColor: '#F1C451',
                  color: '#000',
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: '#e0b341'
                  }
                }}
              >
                <DoneIcon sx={{ mr: 1 }} /> Close
              </Button>
            </Box>
          </ModalContent>
        </Modal>
        {/* Form Section */}
        <FormContainer>
          <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>Horoscope Form</Typography>

          {/* Name & Gender */}
          <Typography fontWeight="bold" mt={2}>Name & Gender</Typography>
          <Grid container spacing={1} alignItems="center" mt={1}>
            <Grid item><LabelBox>Name</LabelBox></Grid>
            <Grid item xs>
              <CustomInput
                placeholder="Enter Your Full Name"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={!!error.name}
                helperText={error.name}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid item><LabelBox>Gender</LabelBox></Grid>
            <Grid item xs>
              <GenderToggle
                value={gender}
                exclusive
                onChange={(e, newValue) => setGender(newValue)}
                error={!!error.gender}
              >
                <ToggleButton value="male">Male</ToggleButton>
                <ToggleButton value="female">Female</ToggleButton>
              </GenderToggle>
              {error.gender && <Typography color="error" variant="body2">{error.gender}</Typography>}
            </Grid>
          </Grid>

          {/* Phone Number */}
          <Typography fontWeight="bold" mt={3}>Contact Details</Typography>
          <Grid container spacing={2} alignItems="center" mt={1}>
            <Grid item><LabelBox>Phone</LabelBox></Grid>
            <Grid item xs>
              <CustomInput
                type="number"
                placeholder="Enter Your Phone Number"
                fullWidth
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                error={!!error.phoneNumber}
                helperText={error.phoneNumber}
              />
            </Grid>
          </Grid>

          {/* Zodiac Sign */}
          <Typography fontWeight="bold" mt={3}>Zodiac Sign</Typography>
          <Grid container spacing={2} alignItems="center" mt={1}>
            <Grid item><LabelBox>Zodiac</LabelBox></Grid>
            <Grid item xs>
              <FormControl fullWidth>
                <InputLabel>Zodiac Sign</InputLabel>
                <Select
                  value={zodiac}
                  onChange={(e) => setZodiac(e.target.value)}
                  label="Zodiac Sign"
                  error={!!error.zodiac}
                >
                  <MenuItem value="dontknow">Don't Know</MenuItem>
                  <MenuItem value="Aries">Aries</MenuItem>
                  <MenuItem value="Taurus">Taurus</MenuItem>
                  <MenuItem value="Gemini">Gemini</MenuItem>
                  <MenuItem value="Cancer">Cancer</MenuItem>
                  <MenuItem value="Leo">Leo</MenuItem>
                  <MenuItem value="Virgo">Virgo</MenuItem>
                  <MenuItem value="Libra">Libra</MenuItem>
                  <MenuItem value="Scorpio">Scorpio</MenuItem>
                  <MenuItem value="Sagittarius">Sagittarius</MenuItem>
                  <MenuItem value="Capricorn">Capricorn</MenuItem>
                  <MenuItem value="Aquarius">Aquarius</MenuItem>
                  <MenuItem value="Pisces">Pisces</MenuItem>
                </Select>
                {error.zodiac && <Typography color="error" variant="body2">{error.zodiac}</Typography>}
              </FormControl>
            </Grid>
          </Grid>

          {/* Birth Details */}
          <Typography fontWeight="bold" mt={3}>Birth Details</Typography>

          {/* Date Picker */}
          <Grid container spacing={2} alignItems="center" mt={1}>
            <Grid item><LabelBox>Date</LabelBox></Grid>
            <Grid item xs>
              <DatePicker
                value={date}
                onChange={(newValue) => setDate(newValue)}
                renderInput={(params) => (
                  <CustomInput
                    {...params}
                    fullWidth
                    error={!!error.date}
                    helperText={error.date}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Time Picker */}
          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid item><LabelBox>Time</LabelBox></Grid>
            <Grid item xs>
              <TimePicker
                value={time}
                onChange={(newValue) => setTime(newValue)}
                renderInput={(params) => (
                  <CustomInput
                    {...params}
                    fullWidth
                    error={!!error.time}
                    helperText={error.time}
                  />
                )}
                ampm={false}
              />
            </Grid>
          </Grid>

          {/* Place Input */}
          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid item><LabelBox>Place</LabelBox></Grid>
            <Grid item xs>
              <CustomInput
                placeholder="Search Your Location"
                fullWidth
                value={place}
                onChange={(e) => setPlace(e.target.value)}
                error={!!error.place}
                helperText={error.place}
              />
            </Grid>
          </Grid>

          {/* Family Members Section */}
          <Box mt={2}>
            <Typography variant="subtitle1" fontWeight="bold" mb={2}>
              Family Members & Friends ({familyMembers.length})
            </Typography>


            <Grid container spacing={2}>
              {familyMembers.map((member, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box sx={{
                    background: "linear-gradient(145deg, #ffffff, #f5f5f5)",
                    borderRadius: 2,
                    p: 2,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    position: 'relative',
                    borderLeft: '4px solid #F1C451',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
                    }
                  }}>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: 'error.main',
                        backgroundColor: 'rgba(255,0,0,0.1)',
                        '&:hover': {
                          backgroundColor: 'rgba(255,0,0,0.2)'
                        }
                      }}
                      onClick={() => removeFamilyMember(index)}
                      size="small"
                    >
                      <Close fontSize="small" />
                    </IconButton>

                    <Box display="flex" alignItems="center" mb={1}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          backgroundColor: member.gender === 'male' ? '#e3f2fd' : '#fce4ec',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mr: 2,
                          color: member.gender === 'male' ? '#1976d2' : '#c2185b',
                          fontWeight: 'bold',
                          fontSize: 14
                        }}
                      >
                        {member.gender === 'male' ? '♂' : member.gender === 'female' ? '♀' : ''}
                      </Box>
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {member.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {member.zodiac}
                        </Typography>
                      </Box>
                    </Box>


                    <Grid container spacing={1} mt={1}>
                      <Grid item xs={6}>
                        <Box sx={{
                          backgroundColor: 'rgba(241, 196, 81, 0.1)',
                          borderRadius: 1,
                          p: 1,
                          textAlign: 'center'
                        }}>
                          <Typography variant="caption" color="text.secondary">
                            Date of Birth
                          </Typography>
                          <Typography variant="body2" fontWeight="medium">
                            {member.date ? dayjs(member.date).format('DD MMM YYYY') : 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box sx={{
                          backgroundColor: 'rgba(241, 196, 81, 0.1)',
                          borderRadius: 1,
                          p: 1,
                          textAlign: 'center'
                        }}>
                          <Typography variant="caption" color="text.secondary">
                            Birth Time
                          </Typography>
                          <Typography variant="body2" fontWeight="medium">
                            {member.time ? dayjs(member.time).format('hh:mm A') : 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Button
              variant="outlined"
              startIcon={<Add />}
              onClick={handleOpenDialog}
              sx={{
                mt: 2,
                width: '100%',
                borderStyle: 'dashed',
                borderWidth: 1.5,
                py: 1.5,
                '&:hover': {
                  borderStyle: 'dashed',
                  borderWidth: 1.5,
                  backgroundColor: 'rgba(241, 196, 81, 0.05)'
                }
              }}
            >
              Add Family Member/Friend
            </Button>
          </Box>

          {/* Submit Button */}
          <Button
            variant="contained"
            sx={{
              background: "#F1C451",
              color: "#000",
              fontWeight: "bold",
              mt: 4,
              py: 1.5,
              width: "100%",
              borderRadius: 2,
              "&:hover": { background: "#E1B440" },
            }}
            onClick={handleSubmit}
          >
            Book a Horoscope
          </Button>
        </FormContainer>

        {/* Add Family Member Dialog */}
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
          <DialogTitle>Add Family Member/Friend</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <CustomInput
                  label="Name"
                  fullWidth
                  value={currentMember.name}
                  // error={!!errorMessages.name}
                  // helperText={errorMessages.name}
                  onChange={(e) => handleMemberChange('name', e.target.value)}
                />
              </Grid>
              <Typography style={{ fontSize: '13px', color: 'red', marginLeft: '20px' }}>{errorMessages.name}</Typography>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    value={currentMember.gender}
                    onChange={(e) => handleMemberChange('gender', e.target.value)}
                    label="Gender"
                  >
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Typography style={{ fontSize: '13px', color: 'red', marginLeft: '20px' }}>{errorMessages.gender}</Typography>


              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Zodiac Sign</InputLabel>
                  <Select
                    value={currentMember.zodiac}
                    onChange={(e) => handleMemberChange('zodiac', e.target.value)}
                    label="Zodiac Sign"
                  >
                    <MenuItem value="dontknow">Don't Know</MenuItem>
                    <MenuItem value="Aries">Aries</MenuItem>
                    <MenuItem value="Taurus">Taurus</MenuItem>
                    <MenuItem value="Gemini">Gemini</MenuItem>
                    <MenuItem value="Cancer">Cancer</MenuItem>
                    <MenuItem value="Leo">Leo</MenuItem>
                    <MenuItem value="Virgo">Virgo</MenuItem>
                    <MenuItem value="Libra">Libra</MenuItem>
                    <MenuItem value="Scorpio">Scorpio</MenuItem>
                    <MenuItem value="Sagittarius">Sagittarius</MenuItem>
                    <MenuItem value="Capricorn">Capricorn</MenuItem>
                    <MenuItem value="Aquarius">Aquarius</MenuItem>
                    <MenuItem value="Pisces">Pisces</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Typography style={{ fontSize: '13px', color: 'red', marginLeft: '20px' }}>{errorMessages.zodiac}</Typography>

              <Grid item xs={12}>
                <DatePicker
                  label="Date of Birth"
                  value={currentMember.date}
                  onChange={(newValue) => handleMemberChange('date', newValue)}
                  renderInput={(params) => (
                    <CustomInput
                      {...params}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Typography style={{ fontSize: '13px', color: 'red', marginLeft: '20px' }}>{errorMessages.date}</Typography>

              <Grid item xs={12}>
                <TimePicker
                  label="Time of Birth (Optional)"
                  value={currentMember.time}
                  onChange={(newValue) => handleMemberChange('time', newValue)}
                  renderInput={(params) => (
                    <CustomInput
                      {...params}
                      fullWidth
                    />
                  )}
                  ampm={false}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button
              onClick={addFamilyMember}
              variant="contained"
              sx={{ background: "#F1C451", color: "#000" }}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Background>
    </LocalizationProvider>
  );
};

export default HoroscopeForm;

// Styled components (keep the same as before)
const CustomInput = styled(TextField)(({ theme }) => ({
  background: "#EAEAEA",
  borderRadius: 5,
  flex: 1,
  "& .MuiOutlinedInput-root": {
    "& fieldset": { border: "none" },
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

const LabelBox = styled(Box)(({ theme }) => ({
  background: "#264734",
  color: "#fff",
  fontWeight: "bold",
  padding: "15px 20px",
  borderRadius: 5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 120,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginBottom: 8,
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  background: "#fff",
  padding: "30px",
  borderRadius: 10,
  maxWidth: 750,
  width: "100%",
  margin: "auto",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down('sm')]: {
    padding: "15px",
    marginTop: "10px",
  },
}));

const GenderToggle = styled(ToggleButtonGroup)({
  background: "#EAEAEA",
  borderRadius: 5,
  display: "flex",
  flex: 1,
  "& .MuiToggleButton-root": {
    flex: 1,
    color: "#000",
    fontWeight: "bold",
    transition: "background-color 0.3s",
    "&.Mui-selected": {
      backgroundColor: "#F1C451",
    },
    "&:hover": {
      backgroundColor: "#F1C451",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#F1C451",
    },
    "&:focus": {
      backgroundColor: "#F1C451",
    },
  },
});

const Background = styled(Box)({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
});

const TokenContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: 750,
  marginBottom: 20,
  flexDirection: "row",
  flexWrap: "nowrap",
  [theme.breakpoints.down('sm')]: {
    flexDirection: "row",
    justifyContent: "center",
  },
}));

const TokenBox = styled(Box)({
  background: "#F1C451",
  color: "#000",
  fontWeight: "bold",
  textAlign: "center",
  padding: "15px",
  flex: 1,
  borderRadius: 5,
  margin: "0 5px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "10px",
});

const WaitingTokenBox = styled(Box)({
  background: "none",
  padding: "8px",
  cursor: "pointer",
  borderRadius: "50%",
  '&:hover': {
    backgroundColor: "rgba(241, 196, 81, 0.2)"
  }
});

const MoreTokensIndicator = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  transition: "all 0.3s ease",
  position: 'relative',

  '&:hover': {
    transform: "rotate(90deg)",
    backgroundColor: "rgba(241, 196, 81, 0.3)"
  },

  '& svg': {
    transition: "all 0.3s ease"
  }
});
const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 500,
  backgroundColor: theme?.palette?.background?.paper || '#ffffff', // Fallback to white
  boxShadow: theme?.shadows?.[5] || '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
  padding: theme?.spacing?.(3) || '24px',
  borderRadius: theme?.shape?.borderRadius || '4px',
  maxHeight: '80vh',
  display: 'flex',
  flexDirection: 'column'
}));

const WaitingTokenItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme?.palette?.grey?.[100] || '#f5f5f5',
  borderRadius: theme?.shape?.borderRadius || '4px',
  padding: theme?.spacing?.(2) || '16px',
  marginBottom: theme?.spacing?.(1) || '8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: theme?.palette?.grey?.[200] || '#eeeeee',
    transform: 'translateY(-2px)'
  }
}));